import React, { useState } from "react";

// Components
import { Form, Tabs } from 'react-bulma-components';
import Notes from "./Notes";
import Overlay from "shared/components/overlay/Overlay";

// Constants & utils
import { convertObjNullToEmpty } from "shared/utils";
import { CONTACT_METHOD, DEFERRED, LEAD_STATUS, STAGES } from "shared/enums";

//actions
//import { useAuthUser } from 'shared/state';
//import { makeAPIRequest } from "shared/state/fetch";
//import { useTokenStatus } from "shared/state/auth/actions";

// Styles
import styles from './LeadDetail.module.scss';

const LeadDetail = ({ lead='', onSaveLead, onClose }) => {
    const { Control, Field, Input, Label, Select, Textarea } = Form;
    const normalizedLead = lead && convertObjNullToEmpty(lead);
    const [updatedLead, setUpdatedLead] = useState(normalizedLead);
    const [activeTab, setActiveTab] = useState('details');

    const replaceNullUndefined = (obj) => {
        return obj === null || obj === undefined ? '' : obj;
    }

    const handleInputChange = (e) => {
        setUpdatedLead(prevState => ({
           ...prevState,
           [e.target.name]: e.target.value
        }));
    }

    const handleupdatedLead = (e) => {
        e.preventDefault();
        const other = {
            notes: '',
            owner_id: 1,
            user_id: 1
        }
        const updatedLeadObj = { ...updatedLead, ...other };

        // parent component handles api request
        onSaveLead(updatedLeadObj);
    }

    const handleTabClick = (e) => {
        e.preventDefault();
        setActiveTab(e.target.name);
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setUpdatedLead({});
        onClose();
    }

    const handleOverlayClick = (e) => {
        e.preventDefault();
        onClose();
    }

    return (
        <div className={ styles.wrapper }>
            <div className={ styles.detail }>
                <article className={ styles.inner }>
                    <header className={ styles.header }>
                        <div className={ styles.innerHeader }>
                            <h2>{ updatedLead.title }</h2>
                            <span className={ styles.owner }>
                                <span>Lead Owner</span> { updatedLead.leadOwner[0] }
                            </span>
                        </div>
                    </header>
                    <Tabs className={ styles.tabs }>
                        <Tabs.Tab
                            active={ activeTab === 'details' ? true : false }
                            name="details"
                            onClick={ handleTabClick }>
                            Details
                        </Tabs.Tab>
                        <Tabs.Tab
                            active={ activeTab === 'notes' ? true : false }
                            name="notes"
                            onClick={ handleTabClick }>
                            Notes
                        </Tabs.Tab>
                    </Tabs>
                    <form className={ styles.content } onSubmit={ handleupdatedLead }>
                        <div className={ `${styles.tabContent} ${ activeTab === 'details' ? styles.active : ''}` }>
                            <div className={ styles.user }>
                                <Field>
                                    <Label>Lead Title</Label>
                                    <Control>
                                        <Input
                                            readOnly
                                            name="title"
                                            onChange={ handleInputChange }
                                            required
                                            value={ replaceNullUndefined(updatedLead.title) }
                                        />
                                    </Control>
                                </Field>
                                <Field>
                                    <Label>Contact Method</Label>
                                    <Control>
                                        <Select
                                            name="contact_method"
                                            onChange={ handleInputChange }
                                            value={ replaceNullUndefined(updatedLead.contact_method) }>
                                            <option value="">
                                                - Choose an option -
                                            </option>
                                            { Object.entries(CONTACT_METHOD).map(([status, label], i) => {
                                                return (
                                                    <option key={i} value={ status}>
                                                        {label}
                                                    </option> )
                                                })
                                            }
                                        </Select>
                                    </Control>
                                </Field>

                                <Field style={{ flexBasis: '95%'}}>
                                    <Label>Description</Label>
                                    <Control>
                                        <Textarea
                                            readOnly
                                            onChange={ handleInputChange }
                                            name="description"
                                            value={ updatedLead.description }
                                        />
                                    </Control>
                                </Field>
                            </div>
                            <div className={ styles.lead }>
                                <Field>
                                    <Label>Lead Status</Label>
                                    <Control>
                                        <Select
                                            name="status"
                                            required
                                            onChange={ handleInputChange }
                                            value={ replaceNullUndefined(updatedLead.status) }>
                                            <option value="">
                                                - Choose an option -
                                            </option>
                                            { Object.entries(LEAD_STATUS).map(([status, label], i) => {
                                                return (
                                                    <option key={i} value={ status}>
                                                        {label}
                                                    </option> )
                                                })
                                            }
                                        </Select>
                                        {
                                            updatedLead.status === 'deferred' &&
                                            <Select
                                                name="deferred"
                                                required
                                                onChange={ handleInputChange }
                                                style={{ marginTop: '1.5rem'}}
                                                value={ replaceNullUndefined(updatedLead.deferred) }>
                                                <option value="">
                                                    - Choose a Deferred state -
                                                </option>
                                                { Object.entries(DEFERRED).map(([def, label], i) => {
                                                    return (
                                                        <option key={i} value={ def }>
                                                            { label }
                                                        </option> )
                                                    })
                                                }
                                            </Select>
                                        }
                                    </Control>
                                </Field>
                                <Field>
                                    <Label>Lead Stages</Label>
                                    <Control>
                                        <Select
                                            className={ styles[updatedLead.stages]}
                                            onChange={ handleInputChange }
                                            name="stages"
                                            required
                                            value={ updatedLead.stages }>
                                            <option value="">
                                                - Choose an option -
                                            </option>
                                            { Object.entries(STAGES).map(([status, label], i) => {
                                                return (
                                                    <option key={i} value={ status}>
                                                        {label}
                                                    </option> )
                                                })
                                            }
                                        </Select>
                                    </Control>
                                </Field>
                            </div>
                        </div>

                        <div className={ `${styles.tabContent} ${ activeTab === 'notes' ? styles.active : ''}` }>
                            <Notes data={ replaceNullUndefined(updatedLead.notes) } />
                        </div>
                        { /*
                        <footer className={ styles.actions }>
                            <Button onClick={ handleCancel }>
                                Cancel
                            </Button>
                            <Button
                                className={ styles.secondary }
                                type="submit">
                                Add New Lead
                            </Button>
                        </footer>
                        */ }
                    </form>
                </article>
            </div>
            <Overlay isContained onClick={ handleOverlayClick }/>
        </div>
    )
}

export default LeadDetail;
